export const ApiRoutes = {
    LOGIN: "/Auth/Login",
    GET_CLIENT: "/Client/GetLoginClient",
    GET_CLIENT_SIGNATURE: "/Signature/GetClientSignature",
    GET_CLIENT_INFO: "/Client/GetClientClinicInfo",
    GET_DOCUMENT: "/Document/GetClientDocuments",
    UPDATE_SIGNATURE: "/Signature/CreateClientSignature",
    RESET_PIN: "/Signature/ResetPin",
    GET_PENDING_DOC: "/Document/GetClientPendingDocuments",
    GET_SIGNED_DOC: "/Document/GetClientSignedDocuments",
    GET_VIEW_DOC_URI: "Impersonate/GetImpersonateClient",
    VALIDATE_PIN: "Signature/ValidatePin",
    APPLY_SIGNATURE: "Signature/ApplyClientSignature",
    FORGOT_PASSWORD: "Auth/ForgotPassword?userName=",
    CHANGE_PASSWORD: "/Auth/UpdatePassword",
    GET_DX_LIST: "Client/GetClientDiagnosis?isActive=",
    GET_CARE_PLAN: "Client/GetClientTreatmentPlan?isActive=",
    GET_APPOINTMENT_LIST: "Client/GetClientEvents",
    GET_CLIENT_TREATMENT_PLAN_SIGN: "/Signature/GetClientTreatmentPlanSign",
    APPLY_CLIENT_SIGNATURE: "/Signature/ApplyClientSignature",
    GET_BYPASS_TOKEN: "/Auth/GetByPassAccessToken",
    INSERT_MESSAGE: "/ClientMessage/InsertMessage",
    GET_CLIENT_ASSIGNED_STAFFS_DDL: "/Client/GetClientAssignedStaffsDDL",
    GET_MESSAGE_LIST: "/ClientMessage/GetStaffToClientMessages",
    DELETE_MESSAGE: "/ClientMessage/DeleteMessage",
    GET_CLIENT_ATTACHMENTS: "/ClientMessage/GetMessageAttachmentById?id=",
    GET_UNREAD_MESSAGE_COUNT: "/ClientMessage/GetUnreadMessageCount",
    MARK_MESSAGE_READ: "/ClientMessage/MarkRead",
    GET_LINKED_ACCOUNTS: "/Client/GetLinkedClients",
    SWITCH_CLIENT: "/Auth/ChangeClient?clientId=",
    GET_PARENT_INFO:"Auth/GetLoginParentDetails",
    GET_CLIENT_QUESTIONNAIRES: "Client/GetClientQuestionnaires",
    GET_CP_RESIGN_NOTIFICATION:"Client/GetClientTreatmentPlanReSignNotification",
    // GET_FILLED_DOCS:"Document/GetClientFilledDocuments"
}